import React, { useState } from 'react';
import { Box, Typography, IconButton, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useProperty } from '../../context/PropertyContext';
import Grid from '@mui/material/Grid2';
import { Download as Download2} from '@mui/icons-material';
import { downloadPropertyImagesAsZip } from '../../services/propertyService';
import 'yet-another-react-lightbox/styles.css';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from "yet-another-react-lightbox/plugins/zoom";


const PhotosGallery: React.FC = () => {
  const { selectedProperty } = useProperty();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const { id } = useParams();

  const downloadImages = async () => {
    const images = selectedProperty?.photos;

    if (!images || images.length === 0) {
      console.error("No hay imágenes para descargar.");
      return;
    }
    setIsDownloading(true);
    try {
      await downloadPropertyImagesAsZip(id!, images);
      console.log("El archivo ZIP ha sido descargado exitosamente.");
    } catch (error: any) {
      console.error("Error al descargar el archivo ZIP:", error);
    }
    setIsDownloading(false);
  };

  const handleImageClick = (index: number) => {
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  return (
    <Box sx={{ py: 2, position: 'relative' }}>
      <Grid container spacing={2}>
        {selectedProperty?.photos && selectedProperty.photos.length > 0 ? (
          selectedProperty.photos.map((photo: string, index: number) => {
            const isFullWidth = index % 3 === 0;
            return (
              <Grid size={{xs:12, sm: isFullWidth ? 12 : 6}} key={index}>
                <Box
                  onClick={() => handleImageClick(index)}
                  sx={{
                    height: isFullWidth ? '600px' : '400px',
                    overflow: 'hidden',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    position: 'relative',
                    transition: 'opacity 0.3s',
                    '&:hover': {
                      opacity: 0.85,
                    },
                  }}
                >
                  <img
                    src={photo}
                    alt={`Foto ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                  {index === 0 && (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation(); 
                        downloadImages();
                      }}
                      sx={{
                        position: 'absolute',
                        right: 10,
                        top: 25,
                        zIndex: 2,
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        color: 'black',
                        borderRadius: '50%',
                        padding: '8px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 1)',
                        },
                      }}
                    >
                      {isDownloading ? (
                        <CircularProgress size={20} sx={{ color: 'green' }} />
                      ) : (
                        <Download2 />
                      )}
                    </IconButton>
                  )}
                </Box>
              </Grid>
            );
          })
        ) : (
          <Grid size={{xs: 12}}>
            <Typography variant="h6" align="center">
              No hay fotos disponibles.
            </Typography>
          </Grid>
        )}
      </Grid>

     {isViewerOpen && selectedProperty?.photos && (
        <Lightbox
          open={isViewerOpen}
          close={() => setIsViewerOpen(false)}
          index={photoIndex}
          slides={selectedProperty.photos.map((src) => ({ src }))}
          on={{ view: ({ index }) => setPhotoIndex(index) }}
          plugins={[Zoom]}
          zoom={{
             maxZoomPixelRatio: 2,
            zoomInMultiplier: 2, 
            doubleTapDelay: 300, 
            doubleClickDelay: 300,
            doubleClickMaxStops: 2, 
            keyboardMoveDistance: 50, 
            wheelZoomDistanceFactor: 100, 
            pinchZoomDistanceFactor: 100,
            scrollToZoom: true
          }}
        />
      )}
      <Box
        sx={{
          height: "80px",
          display: { xs: "block", sm: "none" },
          width: "100%",
        }}
      />
    </Box>
  );
};

export default PhotosGallery;
